import { useState } from 'react';
import { Link } from 'wouter';
import { motion, AnimatePresence, useReducedMotion } from 'framer-motion';
import { ArrowRight, ChevronRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Reveal, EASE } from './helpers';

export const FinalCta = () => {
    const reduce = useReducedMotion();
    return (
        <section className="py-32">
            <div className="max-w-4xl mx-auto px-6">
                <Reveal>
                    <div className="relative rounded-3xl px-10 py-20 text-center overflow-hidden" style={{ background: 'linear-gradient(160deg, hsl(210 71% 14%) 0%, hsl(221 83% 22%) 100%)' }}>
                        <motion.div
                            className="absolute -top-20 -left-20 w-72 h-72 rounded-full blur-3xl opacity-30"
                            style={{ background: 'radial-gradient(circle, hsl(221 83% 53%) 0%, transparent 70%)' }}
                            animate={reduce ? undefined : { scale: [1, 1.2, 1], x: [0, 30, 0] }}
                            transition={{ duration: 10, repeat: Infinity, ease: 'easeInOut' }}
                        />
                        <motion.div
                            className="absolute -bottom-20 -right-20 w-80 h-80 rounded-full blur-3xl opacity-25"
                            style={{ background: 'radial-gradient(circle, hsl(265 70% 58%) 0%, transparent 70%)' }}
                            animate={reduce ? undefined : { scale: [1, 1.15, 1], x: [0, -40, 0] }}
                            transition={{ duration: 12, repeat: Infinity, ease: 'easeInOut' }}
                        />
                        <div className="relative">
                            <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white tracking-[-0.025em] leading-[1.05] mb-5">
                                There's a departure on your calendar.
                                <span className="block text-white/60">It's going to cost you six months.</span>
                            </h2>
                            <p className="text-white/70 text-lg mb-10 max-w-xl mx-auto leading-relaxed font-light">
                                Twenty minutes on a call. We'll show you what we'd capture — and what it would save you. No deck, no pitch, no obligation.
                            </p>
                            <div className="flex flex-col sm:flex-row gap-3 justify-center">
                                <Link href="/dashboard">
                                    <Button size="lg" className="px-7 h-12 bg-white text-foreground hover:bg-white/90 gap-2 rounded-full">
                                        Book a 20-min call <ArrowRight className="h-4 w-4" />
                                    </Button>
                                </Link>
                                <Link href="/pricing">
                                    <Button size="lg" variant="outline" className="px-7 h-12 text-white border-white/30 hover:bg-white/10 hover:text-white gap-2 rounded-full">
                                        See pricing <ChevronRight className="h-4 w-4" />
                                    </Button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </Reveal>
            </div>
        </section>
    );
};
